import { render, staticRenderFns } from "./testDeviceDetail.vue?vue&type=template&id=bc76bf5a&scoped=true"
import script from "./testDeviceDetail.vue?vue&type=script&lang=js"
export * from "./testDeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./testDeviceDetail.vue?vue&type=style&index=0&id=bc76bf5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc76bf5a",
  null
  
)

export default component.exports